import { SectionHeading, Panel } from "../../design-system";
import React from "react";

const musicList = [
  {
    link: "https://www.youtube.com/watch?v=5Xaq5yoaqkE",
    image: {
      src: "images/album_humans.jpg",
      alt: "Humans for sale",
    },
    title: "Humans for sale - SINGLE (2024)",
  },
  {
    link: "https://www.youtube.com/watch?v=w4-y5wX87jA&list=PLHaHoyEs2YfMABw-UPe4_iKQLseEXZcHa",
    image: {
      src: "images/album_inner.jpg",
      alt: "Image 1",
    },
    title: "Inner Suffering (2022)",
  },
  {
    link: "https://www.youtube.com/watch?v=UyKoRy8IPVY&list=PLHaHoyEs2YfMvLsKqWd6v6-dt_m3gSEGz",
    image: {
      src: "images/album_abduction.jpg",
      alt: "Image 2",
    },
    title: "Abduction Now (2009)",
  },
  {
    link: "https://youtu.be/AqnJwqvK-_U",
    image: {
      src: "images/album_rehearsal.png",
      alt: "Lost Tapes",
    },
    title: "Lost Tapes (2003)",
  },
  {
    link: "https://www.youtube.com/watch?v=vL2dMspshQ0&list=PLHaHoyEs2YfN43-NJF4c0e6fovnih9dIX",
    image: {
      src: "images/album_espiritual.jpg",
      alt: "Mundo Espiritural",
    },
    title: "Mundo Espiritual (2003)",
  },
];

const Music = () => {
  return (
    <section className="min-w-0 scroll-mt-[25px]" aria-labelledby="music-title">
      <SectionHeading id="music-title" title="MUSIC" eyebrow="THE DISCOGRAPHY" number="03 / SOUND" compact />
      <div className="grid gap-3">
        {musicList.map((item, index) => {
          return (
            <Panel className="grid grid-cols-[92px_1fr] gap-[15px] p-2.5" key={item.title}>
              <a target="_blank" href={item.link} rel="noreferrer" aria-label={`Listen to ${item.title} on YouTube`}>
                <img className="block h-[92px] w-[92px] object-cover" src={item.image.src} alt={item.image.alt} loading="lazy" />
              </a>
              <div className="flex min-w-0 flex-col items-start justify-center gap-3 [&_p]:m-0 [&_p]:text-[13px] [&_p]:font-extrabold [&_p]:leading-[1.35] [&_p]:uppercase [&_a]:text-caption [&_a]:font-extrabold [&_a]:tracking-[.14em] [&_a]:text-music-link [&_a]:no-underline"><p>{item.title}</p><a target="_blank" href={item.link} rel="noreferrer">LISTEN ↗</a></div>
            </Panel>
          );
        })}
      </div>
    </section>
  );
};

export default Music;
